export const env = {
  baseURL: process.env.REACT_APP_API_BASE_URL || 'https://dev.ext-api.mysterydrop.app/app',
  raribleBaseUrl: process.env.REACT_APP_RARIBLE_BASE_URL || 'https://api-staging.rarible.com',
}
